import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Check, Quote } from "lucide-react";
import api from "@/lib/api";

const Stars = ({ n }) => <div className="flex">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`w-4 h-4 ${i <= n ? "fill-[#FFD93D] text-[#FFD93D]" : "text-[#19324A]/15"}`} />)}</div>;

export default function ReviewsSection() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reviews/featured", { params: { limit: 6 } }).then(({ data }) => setData(data)).catch(() => setData({ reviews: [] })); }, []);
  if (!data || data.reviews.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-20" data-testid="reviews-wall">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
        <div>
          <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#FF6B9D]">Verified buyer reviews</p>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#19324A] mt-2">What the pack is saying</h2>
        </div>
        {data.average && (
          <div className="inline-flex items-center gap-2 rounded-full bg-white soft-shadow px-4 py-2" data-testid="reviews-wall-average">
            <Stars n={Math.round(data.average)} /><span className="font-display font-bold text-[#19324A]">{data.average}</span>
            <span className="text-sm text-[#19324A]/55">from {data.total} verified review{data.total === 1 ? "" : "s"}</span>
          </div>
        )}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {data.reviews.map((r, idx) => (
          <article key={r.id} className={`relative bg-white rounded-3xl p-6 soft-shadow card-hover flex flex-col ${idx % 3 === 1 ? "lg:-translate-y-3" : ""}`} data-testid={`wall-review-${r.id}`}>
            <Quote className="absolute top-5 right-5 w-8 h-8 text-[#FFD93D]/40" />
            <div className="flex items-center gap-2"><Stars n={r.rating} /><span className="text-xs font-bold text-[#7ED957] bg-[#7ED957]/15 rounded-full px-2 py-0.5 inline-flex items-center gap-1"><Check className="w-3 h-3" />Verified buyer</span></div>
            {r.title && <h3 className="font-display font-bold text-[#19324A] mt-3 text-base md:text-lg">{r.title}</h3>}
            <p className="text-sm text-[#19324A]/75 mt-2 line-clamp-5 whitespace-pre-line flex-1">{r.body}</p>
            <p className="text-xs text-[#19324A]/50 mt-3">— {r.author_name}{r.age_group ? ` · ${r.age_group}` : ""}</p>
            <Link to={`/product/${r.product.slug}`} className="mt-4 pt-4 border-t border-[#19324A]/8 flex items-center gap-3 group" data-testid={`wall-review-product-${r.id}`}>
              {r.product.image && <img src={r.product.image} alt="" className="w-10 h-10 rounded-xl object-cover bg-[#FFF9EE]" />}
              <span className="text-sm font-semibold text-[#19324A] group-hover:text-[#FF6B9D] transition-colors truncate">{r.product.name}</span>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}
